package ru.it_mozaika.sender.js.application.components.segments

import mui.icons.material.InfoSharp
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get
import react.*
import react.dom.aria.ariaLabelledBy
import react.dom.html.ReactHTML.input
import react.dom.onChange
import ru.it_mozaika.sender.common.EMAIL_REGEX
import ru.it_mozaika.sender.common.models.StaticSegmentEmailsAction
import ru.it_mozaika.sender.common.models.StaticSegmentUpdateEmailsRequest
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import web.cssom.*
import web.html.InputType

external interface UploadEmailsDialogProps: Props {
    var selected: String?
    var onClose: () -> Unit
    var isOpen: Boolean
}
val uploadEmailsDialog = FC<UploadEmailsDialogProps> { props ->
    val (emails, setEmails) = useState<List<String>>(listOf())
    val (emailsInputValue, setEmailInputValue) = useState("")
    val uploadButtonRef = useRef<web.html.HTMLInputElement>()
    val (file, setFile) = useState<org.w3c.files.File>()
    val (action, setAction) = useState(StaticSegmentEmailsAction.Add)
    useEffect(emailsInputValue) {
        val values = emailsInputValue.split(";")
        val result = values.mapNotNull {
            val email = it.trim().lowercase()
            if (EMAIL_REGEX.matches(email)) {
                email
            } else {
                null
            }
        }
        showNotification("Подготовлено ${result.size} адресов из ${values.size} введенных значений", NotyType.Info)
        setEmails {
            val newList = it.plus(result).toSet()
            newList.toList()
        }
    }
    Dialog {
        this.open = props.isOpen
        DialogTitle {
            +"Загрузка список Email-адресов"
        }
        DialogContent {
            Stack {
                sx {
                    padding = 10.px
                    this.justifyContent = JustifyContent.spaceBetween
                }
                this.spacing = responsive(5)
                direction = responsive(StackDirection.column)
                InputLabel {
                    InfoSharp {
                        fontSize = SvgIconSize.large
                        color = SvgIconColor.warning
                    }
                    sx {
                        fontSize = FontSize.medium
                        color = Color("black")
                    }
                    +"Готово к загрузке ${emails.size} адресов"
                }
                RadioGroup {
                    ariaLabelledBy = "static-segment-emails-action-radio-group-label"
                    defaultValue = action.name
                    row = true
                    onChange = { event, _ ->
                        val actionName = event.target.value
                        val selectedAction = StaticSegmentEmailsAction.values().associateBy { it.name }[actionName]
                        if (selectedAction != null) setAction(selectedAction)
                    }
                    StaticSegmentEmailsAction.values().forEach { segmentAction ->
                        FormControlLabel {
                            value = segmentAction.name
                            control = Radio.create {
                                color = RadioColor.secondary
                            }
                            label = ReactNode(segmentAction.ruTitle)
                        }
                    }
                }
                TextField {
                    sx {
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "manual-email-uploads"
                    label = ReactNode("Email-адреса через ';':")
                    required = true
                    type = InputType.text
                    fullWidth = true
                    error = emailsInputValue.isBlank()
                    variant = FormControlVariant.outlined
                    this.onChange = { event ->
                        val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                        setEmailInputValue(newValue)
                    }
                }
                FormControl {
                    input {
                        hidden = true
                        this.accept = ".csv"
                        this.ref = uploadButtonRef
                        type = InputType.file
                        this.onChange = { e ->
                            (e.target as? HTMLInputElement)?.let { input ->
                                input.files?.get(0)?.let { uploadFile ->
                                    setFile(uploadFile)
                                    val reader = FileReader()
                                    reader.onload = { _ ->
                                        val text = reader.result as String
                                        val values = text
                                            .split("\n")
                                            .mapNotNull { row -> row.split(",").firstOrNull() }
                                        val result = values.mapNotNull {
                                            val email = it.trim().lowercase()
                                            if (EMAIL_REGEX.matches(email)) {
                                                email
                                            } else {
                                                null
                                            }
                                        }
                                        showNotification(
                                            "Подготовлено ${result.size} адресов из ${values.size} введенных значений",
                                            NotyType.Info
                                        )
                                        setEmails {
                                            val newList = it.plus(result).toSet()
                                            newList.toList()
                                        }
                                        result
                                    }
                                    reader.readAsText(uploadFile)
                                }
                                input.value = ""
                            }
                        }
                    }
                }
                TextField {
                    value = file?.name ?: ""
                    id = "file-uploads"
                    label = ReactNode("Выберите csv-файл для загрузки:")
                    required = true
                    error = file == null
                    fullWidth = true
                    variant = FormControlVariant.outlined
                    onMouseDown = {
                        it.preventDefault()
                        it.stopPropagation()
                        uploadButtonRef.current?.click()
                    }
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.end
                marginRight = 15.px
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    +"Загрузить"
                    disabled = emails.isEmpty()
                    onClick = {
                        Http.post(
                            "/segments/static/${props.selected}/emails",
                            StaticSegmentUpdateEmailsRequest(emails, action)
                        ) { response ->
                            response.checkResponseError()?.let { error ->
                                showNotification(error, NotyType.Error)
                                return@post
                            }
                            showNotification("Запрос успешно отправлен", NotyType.Success)
                        }
                        props.onClose()
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                        setFile(null)
                    }
                }
            }
        }
    }
}